(() => {
  const body = document.body;
  const menu = document.querySelector('[data-mobile-menu]');
  const backdrop = document.querySelector('[data-menu-backdrop]');
  const toggle = document.querySelector('[data-menu-toggle]');
  const close = document.querySelector('[data-menu-close]');

  const setMenu = (open) => {
    if (!menu || !backdrop || !toggle) return;
    menu.classList.toggle('is-open', open);
    backdrop.classList.toggle('is-open', open);
    body.classList.toggle('menu-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    toggle.setAttribute('aria-expanded', String(open));
    if (open) close?.focus(); else toggle.focus();
  };

  toggle?.addEventListener('click', () => setMenu(true));
  close?.addEventListener('click', () => setMenu(false));
  backdrop?.addEventListener('click', () => setMenu(false));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

  const toast = document.querySelector('.ll-toast');
  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
  };

  document.querySelectorAll('[data-quick-add]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Could not add item');
        const cart = await fetch('/cart.js').then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = `(${cart.item_count})`; });
        document.querySelectorAll('[data-mobile-cart-count]').forEach((count) => { count.textContent = `${cart.item_count}`; });
        button.textContent = 'Added ✓';
        showToast('Added to your bag');
      } catch (error) {
        button.textContent = 'Try again';
        showToast(error.message || 'Something went wrong');
      } finally {
        window.setTimeout(() => { button.disabled = false; button.textContent = original; }, 1600);
      }
    });
  });

  const productSection = document.querySelector('[data-product-section]');
  if (productSection) {
    const jsonNode = document.querySelector('[data-product-json]');
    const variantSelect = productSection.querySelector('[data-variant-select]');
    const optionInputs = productSection.querySelectorAll('.ll-option input');
    if (jsonNode && variantSelect && optionInputs.length) {
      const product = JSON.parse(jsonNode.textContent);
      const updateVariant = () => {
        const values = [...productSection.querySelectorAll('.ll-option')].map((fieldset) => fieldset.querySelector('input:checked')?.value);
        const variant = product.variants.find((item) => item.options.every((option, index) => option === values[index]));
        if (variant) variantSelect.value = variant.id;
      };
      optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
    }
  }

  const revealNodes = document.querySelectorAll('.shopify-section > section, [data-animate]');
  revealNodes.forEach((node) => node.classList.add('ll-reveal'));
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealNodes.forEach((node) => node.classList.add('is-visible'));
  } else {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -45px' });
    revealNodes.forEach((node) => revealObserver.observe(node));
  }

  document.querySelectorAll('[data-reviews]').forEach((section) => {
    const cards = [...section.querySelectorAll('[data-review-card]')];
    const count = section.querySelector('[data-review-count]');
    const previous = section.querySelector('[data-review-prev]');
    const next = section.querySelector('[data-review-next]');
    let active = 0;
    const showReview = (index) => {
      active = (index + cards.length) % cards.length;
      cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === active));
      if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
    };
    previous?.addEventListener('click', () => showReview(active - 1));
    next?.addEventListener('click', () => showReview(active + 1));
  });

  const fieldNotes = [...document.querySelectorAll('[data-field-note]')];
  const syncFieldNoteState = () => body.classList.toggle('note-open', fieldNotes.some((note) => note.open));
  fieldNotes.forEach((note) => {
    note.addEventListener('toggle', () => {
      if (note.open) fieldNotes.forEach((other) => { if (other !== note) other.open = false; });
      syncFieldNoteState();
    });
    note.querySelector('[data-note-close]')?.addEventListener('click', () => {
      note.open = false;
      note.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openNote = fieldNotes.find((note) => note.open);
    if (openNote) {
      openNote.open = false;
      openNote.querySelector('summary')?.focus();
    }
  });
})();
